import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/Button";
import DataTableServerSideRendering from "../../../components/DataTable/DataTableServerSideRendering";
import { Input, Select } from "../../../components/Inputs";
import Loading from "../../../components/Loading/Loading";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";
import ModalUserLimitUpdate from "../../../components/Modal/ModalUserLimitUpdate";
import {
  convertAmountToFrontend,
  convertNumberToFrontend,
} from "../../../helpers/convert";
import { setNotification } from "../../../helpers/notification";

import {
  getUserLimitsRequest,
  getUsersLimitsRequest,
  updateOrganizationLimitsRequest,
  updateUserLimitsRequest,
} from "../../../redux/actions/organizations";
import { userLookupRequest } from "../../../redux/actions/users";

const UserParameters = ({ t }) => {
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.authorization.user);
  const userType = ["PK", "SRJ"];
  const isUser = userType.some((type) => authUser?.username.includes(type));
  // const isUser = authUser?.username.includes("PK");

  // const organization = useSelector(
  //   (state) => state.authorization.user.organization
  // );

  const loggedInOrganizationPk = useSelector(
    (state) => state.organizations.loggedInOrganization
  );

  const usersParamaterList = useSelector(
    (state) => state.organizations.usersParamaterList
  );

  const loggedInOrganization = isUser
    ? usersParamaterList?.organizationLimit
    : loggedInOrganizationPk;
  const succesMessage = useSelector(
    (state) => state.organizations.succesMessage
  );

  const backError = useSelector((state) => state.organizations.customError);

  const updateParametersCompleted = useSelector(
    (state) => state.organizations.updateParametersCompleted
  );

  const loading = useSelector((state) => state.organizations.loading);
  const authorization = useSelector((state) => state.authorization.user);
  const error = useSelector((state) => state.organizations.updateError);

  const userList = useSelector((state) => state.users.userList);

  const [userParametersConfirmationModal, setUserParametersConfirmationModal] =
    useState(false);
  const [maxBuyAmountLimit, setMinAmountLimit] = useState();
  const [maxSellAmountLimit, setMaxAmountLimit] = useState();
  const [minSellPriceLimit, setMinPriceLimit] = useState();
  const [maxBuyPriceLimit, setMaxPriceLimit] = useState();
  const [sortedColumn, setSortedColumn] = useState("productionPeriod");
  const [sortDirection, setSortDirection] = useState("desc");
  const [activePage, setActivePage] = useState(0);
  const [filterUser, setFilterUser] = useState(null);

  const [selectUser, setSelectUser] = useState(null);

  const usersLimitColumns = [
    {
      name: t("pages.default.YEKGParticipation.table.organizationName"),
      selector: "organizationName",
      sortable: true,
      showTitle: true,
    },
    {
      name: t("pages.default.YEKGParticipation.table.userName"),
      selector: "userName",
      sortable: true,
      showTitle: true,
    },

    {
      name: t("pages.default.userParameters.maxBuyAmountLimit"),
      selector: "maxBuyAmountLimit",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.maxBuyAmountLimit);
      },
    },
    {
      name: t("pages.default.userParameters.maxSellAmountLimit"),
      selector: "maxSellAmountLimit",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.maxSellAmountLimit);
      },
    },
    {
      name: t("pages.default.userParameters.minSellPriceLimit"),
      selector: "minSellPriceLimit",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({
          num: row.minSellPriceLimit,
          digit: 2,
        });
      },
    },
    {
      name: t("pages.default.userParameters.maxBuyPriceLimit"),
      selector: "maxBuyPriceLimit",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.maxBuyPriceLimit, digit: 2 });
      },
    },
    {
      name: t("pages.default.certificates.table.process"),
      selector: "process",
      sortable: false,
      width: "140px",
      cell: (row, index) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              title={t("ui.default.review")}
              suffixIcon="edit"
              type="secondary"
              onClick={() => setSelectUser(row)}
              id={`ba-review-${index}`}
            />
          </div>
        );
      },
    },
  ];
  const filterChange = (e) => {
    switch (e.target.name) {
      case "filterUser":
        setFilterUser(e.target.value);
        break;
      default:
        break;
    }
  };

  const filterUserLimit = () => {
    const filters = {
      userId: filterUser,
    };
    dispatch(
      getUsersLimitsRequest({
        ...filters,
      })
    );
    // setDownloadFilter({
    //   ...filters,
    // });
  };

  const updateLimits = () => {
    if (userParametersConfirmationModal) {
      if (isUser) {
        dispatch(
          updateOrganizationLimitsRequest({
            userId: authorization.id,
            maxBuyAmountLimit: parseInt(maxBuyAmountLimit),
            maxSellAmountLimit,
            minSellPriceLimit: parseFloat(minSellPriceLimit),
            maxBuyPriceLimit: parseFloat(maxBuyPriceLimit),
          })
        );
        dispatch(getUsersLimitsRequest({}));
      } else {
        dispatch(
          updateUserLimitsRequest({
            userId: authorization.id,
            maxBuyAmountLimit: parseInt(maxBuyAmountLimit),
            maxSellAmountLimit,
            minSellPriceLimit: parseFloat(minSellPriceLimit),
            maxBuyPriceLimit: parseFloat(maxBuyPriceLimit),
          })
        );
        dispatch(getUserLimitsRequest({}));
      }

      setMinAmountLimit(null);
      setMaxAmountLimit(null);
      setMinPriceLimit(null);
      setMaxPriceLimit(null);
      setUserParametersConfirmationModal(false);
    }

    return true;
  };

  useEffect(() => {
    if (isUser) {
      dispatch(getUsersLimitsRequest({}));
    } else {
      dispatch(getUserLimitsRequest({}));
    }
    dispatch(userLookupRequest({}));
  }, []);

  useEffect(() => {
    if (error) {
      setNotification("error", backError);
    }
    // dispatch(getUserLimitsRequest({}));
  }, [error, backError, dispatch]);

  const limitsChange = (e) => {
    if (e.target.name === "maxBuyAmountLimit") {
      setMinAmountLimit(e.target.value || null);
    }
    if (e.target.name === "maxSellAmountLimit") {
      setMaxAmountLimit(parseInt(e.target.value) || null);
    }
    if (e.target.name === "minSellPriceLimit") {
      setMinPriceLimit(e.target.value || null);
    }
    if (e.target.name === "maxBuyPriceLimit") {
      setMaxPriceLimit(e.target.value || null);
    }
  };

  useEffect(() => {
    // setUserParametersConfirmationModal(false);
    if (updateParametersCompleted) {
      setNotification("success", succesMessage?.message);
      if (isUser) {
        dispatch(getUsersLimitsRequest({}));
      } else {
        dispatch(getUserLimitsRequest({}));
      }
      // dispatch(getUserLimitsRequest({}));
      //dispatch(getUsersLimitsRequest({}));
    }
  }, [updateParametersCompleted]);

  useEffect(() => {
    if (loggedInOrganization) {
      setMinAmountLimit(
        isUser
          ? loggedInOrganization.maxBuyAmountLimit
          : loggedInOrganizationPk.maxBuyAmountLimit
      );
      setMaxAmountLimit(
        isUser
          ? loggedInOrganization.maxSellAmountLimit
          : loggedInOrganizationPk.maxSellAmountLimit
      );
      setMinPriceLimit(
        isUser
          ? loggedInOrganization.minSellPriceLimit
          : loggedInOrganizationPk.minSellPriceLimit
      );
      setMaxPriceLimit(
        isUser
          ? loggedInOrganization.maxBuyPriceLimit
          : loggedInOrganizationPk.maxBuyPriceLimit
      );
    }
  }, [loggedInOrganization]);

  // useEffect(() => {
  //   if (organization) {
  //     setMinAmountLimit(organization.maxBuyAmountLimit);
  //     setMaxAmountLimit(organization.maxSellAmountLimit);
  //     setMinPriceLimit(organization.minSellPriceLimit);
  //     setMaxPriceLimit(organization.maxBuyPriceLimit);
  //   }
  // }, [organization]);

  const sendUserParametersConfirmationToggle = () => {
    setUserParametersConfirmationModal(true);
  };
  const handleClick = (activePage, selector, direction) => {
    console.log("page", activePage, selector, direction);
    setActivePage(activePage);
    dispatch(
      getUsersLimitsRequest({
        page: activePage,
        // selector: selector,
        // direction: direction,
      })
    );
  };
  return (
    <>
      {/* {loading && <Loading text={t("pages.default.userParameters.loading")} />} */}

      <div className="km__p--redemption-edit-modal-body">
        {!loading && (
          <>
            {isUser ? (
              <div className="km__p--certificates-filter">
                <Select
                  options={userList?.userLookupList}
                  name="filterUser"
                  defaultValue={filterUser}
                  onChange={filterChange}
                />

                <Button
                  type="primary"
                  label={t("ui.default.filter")}
                  onClick={filterUserLimit}
                  id="c-filter"
                />
              </div>
            ) : (
              ""
            )}
            <div className="km__p--redemption-operations-inputs-container">
              <div className="km__p--redemption-operations-input-title mt-3">
                {isUser
                  ? t("pages.default.userParameters.OrganizationTitle")
                  : t("pages.default.userParameters.title")}
              </div>
              <br></br>
              <Input
                name="maxBuyAmountLimit"
                type="number"
                min={1}
                max={
                  loggedInOrganization?.checkMaxAmountLimit ??
                  loggedInOrganization?.checkMaxBuyAmountLimit
                }
                pattern="[0-9]+([\.,][0-9]+)?"
                maxlength="9"
                placeholder={`${t("pages.default.userParameters.Max")} ${
                  loggedInOrganization?.checkMaxBuyAmountLimit
                    ? loggedInOrganization?.checkMaxBuyAmountLimit
                    : ""
                }`}
                label={t("pages.default.userParameters.maxBuyAmountLimit")}
                value={maxBuyAmountLimit}
                onChange={limitsChange}
              />
              <Input
                name="maxSellAmountLimit"
                type="number"
                min={1}
                max={
                  loggedInOrganization?.checkMaxAmountLimit ??
                  loggedInOrganization?.checkMaxSellAmountLimit
                }
                pattern="[0-9]+([\.,][0-9]+)?"
                maxlength="9"
                placeholder={`${t("pages.default.userParameters.Max")} ${
                  loggedInOrganization?.checkMaxSellAmountLimit
                    ? loggedInOrganization?.checkMaxSellAmountLimit
                    : ""
                }`}
                label={t("pages.default.userParameters.maxSellAmountLimit")}
                value={maxSellAmountLimit}
                onChange={limitsChange}
              />
              <Input
                name="minSellPriceLimit"
                type="number"
                min={loggedInOrganization?.checkMinSellPriceLimit ?? "0"}
                max={loggedInOrganization?.checkMaxPriceLimit}
                pattern="[0-9]+([\.,][0-9]+)?"
                maxlength="9"
                placeholder={`${t("pages.default.userParameters.Min")} ${
                  (loggedInOrganization?.checkMinSellPriceLimit ??
                    loggedInOrganization?.checkMinPriceLimit) +
                  " - " +
                  t("pages.default.userParameters.Max") +
                  " " +
                  loggedInOrganization?.checkMaxPriceLimit
                }`}
                acceptDecimal
                label={t("pages.default.userParameters.minSellPriceLimit")}
                value={minSellPriceLimit}
                onChange={limitsChange}
              />

              <Input
                name="maxBuyPriceLimit"
                type="number"
                min={loggedInOrganization?.checkMinPriceLimit}
                max={
                  loggedInOrganization?.checkMaxBuyPriceLimit ??
                  loggedInOrganization?.checkMaxPriceLimit
                }
                pattern="[0-9]+([\.,][0-9]+)?"
                maxlength="9"
                placeholder={`${t("pages.default.userParameters.Max")} ${
                  (loggedInOrganization?.checkMaxBuyPriceLimit ??
                    loggedInOrganization?.checkMaxPriceLimit) +
                  " - " +
                  t("pages.default.userParameters.Min") +
                  " " +
                  loggedInOrganization?.checkMinPriceLimit
                }`}
                acceptDecimal
                label={t("pages.default.userParameters.maxBuyPriceLimit")}
                value={maxBuyPriceLimit}
                onChange={limitsChange}
              />
              <div></div>
              <div>
                <Button
                  type="primary"
                  label={t("ui.default.edit")}
                  onClick={sendUserParametersConfirmationToggle}
                />
              </div>
            </div>

            {isUser ? (
              usersParamaterList?.items?.length > 0 ? (
                loading ? (
                  <Loading text={t("pages.default.userParameters.loading")} />
                ) : (
                  <DataTableServerSideRendering
                    columns={usersLimitColumns}
                    data={usersParamaterList?.items}
                    rowKey="id"
                    sortedColumn={sortedColumn}
                    setSortedColumn={setSortedColumn}
                    sortDirection={sortDirection}
                    setSortDirection={setSortDirection}
                    pagination
                    activePage={activePage}
                    totalPageCount={usersParamaterList?.totalPageCount}
                    handleFetchData={handleClick}
                    // subTotals={[
                    //   {
                    //     totalCount: documentCount ? documentCount.totalCount : 0,
                    //     countInPage: documentCount ? documentCount.countInPage : 0,
                    //     sumIndex: 4,
                    //   },
                    // ]}
                  />
                )
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </>
        )}
      </div>
      <ModalConfirmation
        isOpen={userParametersConfirmationModal}
        toggle={() =>
          setUserParametersConfirmationModal(!userParametersConfirmationModal)
        }
        header={t("pages.default.userParameters.confirmation.header")}
        body={t("pages.default.userParameters.confirmation.body")}
        approve={updateLimits}
        // loading={requestLoading}
      />
      <ModalUserLimitUpdate
        toggle={() => setSelectUser()}
        isOpen={selectUser ? true : false}
        selectUser={selectUser}
        loggedInOrganization={loggedInOrganization}
      />
    </>
  );
};
export default UserParameters;
